import { appendToTracking } from 'Tracker'
import Intro from '../ActiveVideo/Intro'

export default appendToTracking(Intro, 'face_motion')
